import { useState } from "react";
import {
  updateListaDifusion,
  createListaDifusion,
} from "../../../services/Api/ListasDifusion";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import alertConfiguration from "../../../utils/alertsUtils";
import { selectProgress } from "../../../../reducers/avisoData/avisoDataSelector";
import { useSelector } from "react-redux";

// Arma el payload de destinatarios. Se ignoran los registros incompletos
// (sin usuario o sin estructura) para que uno solo no rompa el guardado, y la
// estructura se manda únicamente si viene resuelta.
const construirDestinatarios = (usersAdded, incluirId = false) =>
  (usersAdded ?? [])
    .filter((user) => user?.usuario?._id && user?.estructura)
    .map((user) => {
      const estructuraKey = user.estructura.toLowerCase();
      const destinatario = {
        usuario: {
          _id: user.usuario._id,
        },
        estructura: user.estructura,
      };
      if (incluirId && user._id) destinatario._id = user._id;
      if (user[estructuraKey]?._id) {
        destinatario[estructuraKey] = { _id: user[estructuraKey]._id };
      }
      return destinatario;
    });

const useListAddEdit = (userID) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const savedDraft = useSelector(selectProgress);

  const handleCreateList = async (nombre, usersAdded) => {
    try {
      setIsLoading(true);
      const body = {
        nombre,
        creador: userID,
        destinatarios: construirDestinatarios(usersAdded),
      };
      await createListaDifusion(body);
      toast.success(
        "La lista de difusión ha sido agregada exitosamente.",
        alertConfiguration
      );
      if (savedDraft) navigate(-1);
      else navigate("/herramientas/listas-difusion");
    } catch (error) {
      console.log();
      const message =
        error?.response?.data?.message ?? "Error al crear la lista de difusión";
      toast.error(message, alertConfiguration);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateList = async (nombre, usersAdded, id) => {
    try {
      setIsLoading(true);
      const body = {
        nombre,
        destinatarios: construirDestinatarios(usersAdded, true),
      };
      await updateListaDifusion(body, id);
      toast.success(
        "La lista de difusión se ha actualizado exitosamente.",
        alertConfiguration
      );
      if (savedDraft) navigate(-1);
      else navigate("/herramientas/listas-difusion");
    } catch (error) {
      const message =
        error?.response?.data?.message ??
        "Error al actualizar la lista de difusión";
      toast.error(message, alertConfiguration);
    } finally {
      setIsLoading(false);
    }
  };

  return { handleCreateList, handleUpdateList, isLoading };
};

export default useListAddEdit;
